import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "falling-container" };
import { ref } from 'vue';
const count = 30;
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuizFinalDayFallingEffect',
    props: {
        imageSrc: {}
    },
    setup(__props) {
        const items = ref([]);
        // Generate 30 falling items with random properties
        const leftPositions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 15, 25, 35, 45, 55, 65, 75, 85, 95, 5, 12, 22, 32, 42, 52, 62, 72, 82, 92, 18, 28];
        const durations = [12, 14, 16, 13, 15, 14, 12, 14, 13, 15, 16, 12, 14, 15, 13, 15, 16, 12, 14, 15, 13, 15, 16, 12, 14, 15, 13, 15, 16, 12];
        const delays = [0, 2, 4, 6, 1, 3, 5, 7, 0.5, 2.5, 4.5, 6.5, 1.5, 3.5, 5.5, 7.5, 0.2, 2.2, 4.2, 6.2, 0.8, 2.8, 4.8, 6.8, 0.3, 2.3, 4.3, 6.3, 1.2, 3.2];
        const sizes = [40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50];
        for (let i = 0; i < count; i++) {
            items.value.push({
                id: i,
                left: leftPositions[i],
                duration: durations[i],
                delay: delays[i],
                size: sizes[i]
            });
        }
        return (_ctx, _cache) => {
            const _component_v_img = _resolveComponent("v-img");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "falling-item",
                        style: _normalizeStyle({
                            '--left': `${item.left}%`,
                            '--duration': `${item.duration}s`,
                            '--delay': `${item.delay}s`,
                            '--size': `${item.size}px`,
                            'width': `${item.size}px`,
                            'height': `${item.size}px`
                        })
                    }, [
                        _createVNode(_component_v_img, {
                            src: _ctx.imageSrc,
                            class: "falling-image"
                        }, null, 8, ["src"])
                    ], 4));
                }), 128))
            ]));
        };
    }
});
